import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@comparethemarketau/manor-button';

import { onReplaceLinkClick } from 'ctm-util-functions';

const useStyles = createUseStyles((theme) => ({
    maxContent: {
        width: 'max-content'
    },
    tertiary: {
        margin: 0,
        padding: 0,
        width: '100%',
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.base,
        lineHeight: '2rem',
        '&:hover': {
            background: 'unset'
        }
    },
    bordered: {
        margin: 0,
        height: theme.spacing[48]
    }
}));

const BackToResultsButton = ({ className, variant, label }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const handleClick = (event) => {
        onReplaceLinkClick(event, '/car-insurance/journey/results');
    };

    return (
        <div className={classNames('test-backToResultsButton', variant === 'tertiary' && classes.maxContent, className)}>
            <Button
                trackingLabel="Back to results button"
                variant={variant}
                icon={faArrowLeft}
                className={variant === 'tertiary' ? classes.tertiary : classes.bordered}
                handleClick={handleClick}
            >
                {
                    label || 'Back to results'
                }
            </Button>
        </div>
    );
};

BackToResultsButton.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.oneOf(['tertiary', 'secondary', 'primary'])
};

export { BackToResultsButton };
